export enum EWebsiteThemeColorNames {
    light = 'light',
    dark = 'dark',
    primary = 'primary',
    secondary = 'secondary',
    accent = 'accent',
}
